<template>
	<select :id="'subforestry_id_' + this.id" @change="change" v-model="selected" class='form-control table-control my-control' data-num='f_27' data-table='1'>
		<option v-for="option in options" :value='option.id'>
			{{ option.name }}
		</option>
	</select>
</template>

<script>
	import {DB} from './../../../constants'
	const SUBFORESTRY = 'subforestrie_list.php'

	import {EventBus} from '../../../lib/EventBus'
	
	export default {
		name: 'subforestry',
		data: function () { 
			return {
				id: `${this.type}_localforestry_${this.line_count}`,
				selected: '0',
				options: []
			}
		},
		props: {
			line_count: 0,
			lf_id: null,
			sf_id: null,
			type: ''
		},
		methods: {
			fill: function (id) {
				fetch(DB + SUBFORESTRY + '?id=' + id)
				.then(data => data.json())
				.then(data => {
					if (data) {
						if(this.$props.sf_id)
							this.selected = this.$props.sf_id
						this.options = [...data];
					}
					else {
						this.options = []
					}
				})
				.catch(err => console.log(err))
			},
			change: function () {
				console.warn(this.selected)
				EventBus.$emit(`${this.type}_subforestry`, {index: this.line_count, value: this.selected})
			}
		},
		created: function () {
			//console.log('on', 'localforestry_id_' + this.id)
			EventBus.$on(`${this.type}_localforestry_${this.line_count}`, id => {
				this.fill(id)
			})

			if(this.$props.lf_id && this.$props.sf_id)
			{
				this.fill(this.$props.lf_id)
			}
		},
		beforeDestroy () {
			EventBus.$off(`${this.type}_localforestry_${this.line_count}`)
		}
	}
</script>


// WEBPACK FOOTER //
// subforestry.vue?866766bc